module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"v-text-1":"Lataa käräjäoikeuden ratkaisu"},"se":{"v-text-1":"Ladda ner tingsrättens beslut "},"en":{"v-text-1":"Download court\u0027s decision"}}')
  delete Component.options._Ctor
}
